import { NETWORK_STATUS } from "../NetworkPingConstants"

export default function getNetworkPingPromise(options){
    const { url, mode, apiFunction, passIf, name } = options

    if(url){
        return new Promise(async function(resolve, reject){
            await fetch(url, {
                mode: mode
            }).then((response)=>{
              console.log("Test network ping at", url, response)
              if(response.status !== undefined){
                if(response.status !== 0){
                    resolve({
                      name: name,
                      status: NETWORK_STATUS.success
                    })
                }else{
                    reject({
                      name:name, 
                      status: response.status
                    })
                }
              }else{
                console.error("Error getNetworkPingPromise failed to fetch", response)
                reject({
                  name: name, 
                  status: response
                })
              }
            }).catch((err)=>{
              console.error("Error getNetworkPingPromise error thrown", err)
              reject({
                name: name, 
                status: err
              })
            })
        })
    }
    if(apiFunction){
        return new Promise(async function(resolve, reject){
            await apiFunction().then((response)=>{
              console.log("Test network ping api function", response)
              if(passIf(response)){
                resolve({
                  name: name,
                  status: NETWORK_STATUS.success
                })
              }else{
                reject({
                  name:name, 
                  status: response.status
                })
              }
            }).catch((err)=>{
              console.error(err)
              reject({
                name: name, 
                status: err
              })
            })
        })
    }

    return new Promise(function(resolve, reject){
        reject("You need to specific either url or an api function in getNetworkPingPromise()'s option field.")
    })
}